import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="input-char-count"
// Contador de caracteres para un `input`/`textarea` normal, con AVISO en vez de bloqueo.
//
// El contador legacy (`window.inputCharCount`) no sirve aquí: lee el atributo `maxlength`
// para pintar el denominador, y este campo no lleva `maxlength` a propósito — pasarse del
// umbral no impide guardar, solo significa que el cliente de correo cortará el texto en la
// bandeja de entrada (ENH-RNK-4745).
export default class extends Controller {
  static targets = ['input', 'counter', 'aviso']
  static values = { max: Number }

  // El formulario puede llegar ya relleno: al editar una newsletter existente, y también
  // tras un `render :edit` por error de validación. Sin esta sincronización el contador
  // aparecería en blanco hasta la primera pulsación.
  connect () {
    this.actualizar()
  }

  actualizar () {
    if (!this.hasInputTarget) return

    const longitud = this.inputTarget.value.length

    if (this.hasCounterTarget) this.counterTarget.textContent = `${longitud}/${this.maxValue}`
    if (this.hasAvisoTarget) this.avisoTarget.hidden = longitud <= this.maxValue
  }
}
